<template>
  <div id="filter-component" :class="[{'disabled': disabled}]" style="padding-left:10px" align="right">
    <div id="filter-pop-up-field"
         :class="['module-color-border', {'active': !disabled && active}]"
    >
      <button type="submit" id="filterbtn" class="module-color-background"
              ref="filterButton"
              @click="setFilterActive">
        <font-awesome-icon v-if="!active" icon="filter" style="transition: all 0.3s ease;" />
        <font-awesome-icon v-else icon="times" size="lg" style="padding-left: 2px;transition: all 0.3s ease;"  />
      </button>
    </div>
    <div v-if="active"
         id="results"
         style="background: white"
    >
      <Loading :visible=loading />
      <div id="top"></div>
      <div class="foldout" align="left">
        <div class="filter-head">

          <div v-if="countObjects() === 0" class="head-info">
            <span class="module-color filter-message">Kaart Filteren</span>
          </div>
          <div v-else class="head-info">
            <span class="module-color filter-message">{{ countObjects() }}</span>
            <span class="module-color filter-message"> filter(s) geselecteerd</span>
          </div>
          <a id="reset-filters" class="btn module-color-background" v-on:click="resetFilters">
            <span class="icon icon-close"></span>
            Reset filters
          </a>
        </div>
        <div class="filter-body">
          <div class="filterselectbox" >
            <label class="control control-checkbox">
              <input name="show_deleted" type="checkbox"
                     v-model="filters.deleted" @change="useFilter">
              <span class="control-indicator"></span>
              <span class="filter-name" style="font-size: smaller;">
                Toon verwijderde objecten op de kaart</span>
            </label>
          </div>
          <div class="filterselectbox">
            <label class="control control-checkbox">
              <input name="show_obstructed" type="checkbox"
                     v-model="filters.obstructed" @change="useFilter">
              <span class="control-indicator"></span>
              <span class="filter-name" style="font-size: smaller;">
                Toon alleen gestremde objecten op de kaart</span>
            </label>
          </div>
        </div>
        <SmallCollapsePanel
          :title="$tc('models.actionpriority',1) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('actionPriority')"
          :showCollapseAction="false"
        >
          <div v-for="actionPriority in actionPriorities"
               :key="actionPriority.id" class="filterselectbox">
            <label class="control control-checkbox">
              <input type="checkbox"
                     :value="actionPriority.id"
                     v-model="filters.actionPriority"
                     @change="useFilter">
              <span class="control-indicator"></span>
              <span class="filter-name" style="font-size: smaller;">
                {{actionPriority.name}}
              </span>
            </label>
          </div>
        </SmallCollapsePanel>
        <SmallCollapsePanel
          :title="$tc('models.actionstatus',2) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('actionStatus')"
          :showCollapseAction="false"
        >
          <div v-for="actionStatus in Object.values(actionStatuses).sort((a, b) => Number(a.weight) - Number(b.weight))"
               :key="actionStatus.id" class="filterselectbox">
            <label class="control control-checkbox">
              <input type="checkbox"
                     :value="actionStatus.id"
                     v-model="filters.actionStatus"
                     @change="useFilter">
              <span class="control-indicator"></span>
              <span class="filter-name" style="font-size: smaller;">
                {{actionStatus.name}}
              </span>
            </label>
          </div>
        </SmallCollapsePanel>
        <SmallCollapsePanel
          :title="$tc('models.dynamicactiontype',2) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('dynamicActionType')"
          :showCollapseAction="false"
        >
          <SmallSubCollapsePanel
            v-for="dynamicActionTypeCategory in dynamicActionTypeCategories"
            :key="dynamicActionTypeCategory.id"
            :loading=false
            :title="dynamicActionTypeCategory.name"
            :showCount=true
            :count="countSubType('dynamicActionType', actionTypesByCategoryId(dynamicActionTypeCategory.id).map(item => item.id))"
          >
            <div v-for="dynamicActionType in actionTypesByCategoryId(dynamicActionTypeCategory.id)"
                  :key="dynamicActionType.id" class="filterselectbox">
              <label class="control control-checkbox">
                <input type="checkbox"
                       :value="dynamicActionType.id"
                       v-model="filters.dynamicActionType"
                       @change="useFilter">
                <span class="control-indicator"></span>
                <span class="filter-name" style="font-size: smaller;">
                {{dynamicActionType.name}}
              </span>
              </label>
            </div>
          </SmallSubCollapsePanel>
        </SmallCollapsePanel>
        <SmallCollapsePanel
          :title="$tc('models.mapobjectstatus',2) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('mapObjectStatus')"
          :showCollapseAction="false"
        >
          <div v-for="mapObjectStatus in mapObjectStatuses"
               :key="mapObjectStatus.id" class="filterselectbox">
            <label class="control control-checkbox">
              <input type="checkbox"
                     :value="mapObjectStatus.id"
                     v-model="filters.mapObjectStatus"
                     @change="useFilter">
              <span class="control-indicator"></span>
              <span class="filter-name" style="font-size: smaller;">
                {{mapObjectStatus.name}}
              </span>
            </label>
          </div>
        </SmallCollapsePanel>
        <SmallCollapsePanel
          :title="$tc('models.mapobjecttype',2) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('mapObjectType')"
          :showCollapseAction="false"
        >
          <SmallSubCollapsePanel
            v-for="mapObjectCategory in mapObjectCategories"
            :key="mapObjectCategory.id"
            :loading=false
            :title="mapObjectCategory.name"
            :showCount=true
            :count="countSubType('mapObjectType', typesByCategoryId(mapObjectCategory.id).map(item => item.id))"
            >
            <div v-for="mapObjectType in typesByCategoryId(mapObjectCategory.id)"
                 :key="mapObjectType.id" class="filterselectbox">
              <label class="control control-checkbox">
                <input type="checkbox"
                       :value="mapObjectType.id"
                       v-model="filters.mapObjectType"
                       @change="useFilter">
                <span class="control-indicator"></span>
                <span class="filter-name" style="font-size: smaller;">
                {{mapObjectType.name}}
              </span>
              </label>
            </div>
          </SmallSubCollapsePanel>
        </SmallCollapsePanel>
        <SmallCollapsePanel
          :title="$tc('models.selection',2) | capitalize"
          :loading=false
          :showCount=true
          :count="countObjects('mapObjectSelection')"
          :showCollapseAction="false"
        >
          <SmallSubCollapsePanel
            v-for="mapObjectSelectionType in mapObjectSelectionTypes"
            :key="mapObjectSelectionType.id"
            :loading=false
            :title="mapObjectSelectionType.name"
            :showCount=true
            :count="countSubType('mapObjectSelection', selectionsByTypeId(mapObjectSelectionType.id).map(item => item.id))"
          >
            <div v-for="mapObjectSelection in selectionsByTypeId(mapObjectSelectionType.id)"
                 :key="mapObjectSelection.id" class="filterselectbox">
              <label class="control control-checkbox">
                <input type="checkbox"
                       :value="mapObjectSelection.id"
                       v-model="filters.mapObjectSelection"
                       @change="useFilter">
                <span class="control-indicator"></span>
                <span class="filter-name" style="font-size: smaller;">
                {{mapObjectSelection.name}}
              </span>
              </label>
            </div>
          </SmallSubCollapsePanel>
        </SmallCollapsePanel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Loading from '../Loading.vue';
import SmallCollapsePanel from '@/components/SmallCollapsePanel.vue';
import SmallSubCollapsePanel from '@/components/SmallSubCollapsePanel.vue';
import EventBus from '@/events/event-bus';
import * as dataCache from '@/store/cache/dataCache';

export default {
  name: 'MapFilter',
  components: {
    SmallCollapsePanel,
    SmallSubCollapsePanel,
    Loading,
  },
  data() {
    return {
      active: false,
      disabled: false,
      reset: false,
      filters: {
        actionPriority: [],
        actionStatus: [],
        dynamicActionType: [],
        mapObjectStatus: [],
        mapObjectType: [],
        mapObjectSelection: [],
        obstructed: false,
        deleted: false,
      },
      loading: false,
      types: [
        'priority',
        'actionstatus',
        'dynamicaction',
        'mapobjectstatus',
        'mapobjectselections',
        'mapobjecttypes',
      ],
    };
  },
  computed: {
    ...mapGetters({
      networkId: 'switcher/getNetworkId',
      mapObjectTypes: 'settings/getMapObjectTypes',
      actionStatuses: 'settings/getActionStatuses',
      actionPriorities: 'settings/getActionPriorities',
      dynamicActionTypes: 'settings/getDynamicActionTypes',
      dynamicActionTypeCategories: 'settings/getDynamicActionTypeCategories',
      mapObjectCategories: 'settings/getMapObjectCategories',
      mapObjectStatuses: 'settings/getMapObjectStatuses',
      mapObjectSelectionTypes: 'settings/getMapObjectSelectionTypes',
    }),
  },
  methods: {
    ...mapActions({
      setFilterForMap: 'settings/setFilter',
      resetFilterForMap: 'settings/resetFilter',
    }),
    setFilterActive() {
      if (!this.disabled) {
        this.active = !this.active;
      }
    },
    typesByCategoryId(categoryId) {
      return Object.values(this.mapObjectTypes).filter(item => item.map_object_category_id === categoryId);
    },
    selectionsByTypeId(typeId) {
      return Object.values(dataCache.getSelections()).filter(item => item.map_object_selection_type_id === typeId);
    },
    actionTypesByCategoryId(categoryId) {
      return Object.values(this.dynamicActionTypes).filter(item => item.dynamic_action_type_category_id === categoryId);
    },
    countObjects(filterType) {
      if (filterType) {
        return this.filters[filterType].length;
      }
      let count = 0;
      Object.keys(this.filters).forEach((key) => {
        if (Array.isArray(this.filters[key])) {
          count += this.filters[key].length;
        } else {
          count += (this.filters[key] ? 1 : 0);
        }
      });
      return count;
    },
    countSubType(filterType, filterIds) {
      if (!filterType) {
        return 0;
      }
      return this.filters[filterType].filter(item => filterIds.includes(item)).length;
    },
    hasActiveFilters() {
      return Object.values(this.filters).some((value) => {
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        if (typeof value === 'boolean') {
          return value === true;
        }
        return false;
      });
    },
    resetFilters() {
      if (!this.hasActiveFilters()) {
        return;
      }
      this.loading = true;
      Object.keys(this.filters).forEach((key) => {
        if (Array.isArray(this.filters[key])) {
          this.filters[key] = [];
        } else {
          this.filters[key] = false;
        }
      });
      this.resetFilterForMap();
      EventBus.$emit('Map.redraw');
      this.loading = false;
    },
    useFilter() {
      console.log('setFilter', { filter: this.filters });
      this.setFilterForMap({ filter: this.filters });
      EventBus.$emit('Map.redraw');
    },
  },
  mounted() {
    EventBus.$on('Filter.reset', () => {
      this.resetFilters();
    });
    EventBus.$on('Filter.disable', () => {
      this.disabled = true;
      this.active = false;
      this.resetFilters();
    });
    EventBus.$on('Filter.enable', () => {
      this.disabled = false;
    });
  },
  watch: {
    filters(newVal, oldVal) {
      console.log('watch filter', newVal, oldVal);
    },
  },
};
</script>

<style scoped>
#filter-component {
  float: left;
}

#filter-component #filter-pop-up-field {
  position: relative;
  width: 0;
  margin-bottom: 15px;
  overflow: hidden;
  height: 50px;
  padding: 0 46px 0 2px;
  border: 1px solid var(--module-color);
  border-radius: 555px;
  font-weight: 300;
  line-height: 36px;
  background: #fff;
}
#filter-component #filter-pop-up-field #filterbtn {
  position: absolute;
  right: 0;
  top: 25px;
  transform: translateY(-50%);
  font-size: 1em;
  color: var(--module-color);
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: none;
  background: none;
  padding: 0;
  border-radius: 555px;
  display: inline-block;
  font-weight: 300;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: .1em;
  -webkit-appearance: button;
  cursor: pointer;
}
#filter-component.disabled #filter-pop-up-field {
  border: 1px solid #e3e3e3 !important;
  background-color: #e3e3e3 !important;
}
#filter-component.disabled #filter-pop-up-field #filterbtn {
  color: #fff !important;
  cursor: default !important;
}
#filter-component .filter-head {
  border-bottom: 1px solid #d9dadb;
}
#filter-component #results {
  max-height: 80vh;
  position: absolute;
  width: 360px;
  right: -5px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
#filter-component #results .foldout {
  overflow-y: auto;
  max-height: 80vh;
  border-radius: 10px;
}
.filterselectbox{
  line-height: 32px;
  min-height: 30px;
  background: #f2f7fe;
  padding-left: 5px;
  padding-right: 5px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.head-info{
  display: inline-block;
  padding:10px;
  width: 50%;
  color: var(--module-color);
}
#top {
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent #fff;
  width: 0;
  height: 0;
  position: absolute;
  right: 20px;
  top: -10px;
  border-style: solid;
}
#reset-filters {
  font-size: .55em;
  text-transform: uppercase;
  padding: 0 8px 0 8px;
  height: 24px;
  line-height: 24px;
  float: right;
  color: #fff;
  text-decoration: none;
  letter-spacing: .1em;
  position: relative;
  margin-top: 8px;
  margin-right: 8px;
}
.control-indicator {
  margin-top: 6px;
}
.filterselectbox:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
